<template>
  <div class="singleDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :close-on-click-modal="false" :title="dialogTitle" width="910px" @close="onClose">
      <div class="header-line" />
      <div class="section-title" />

      <div class="form-container">
        <el-form ref="form" :model="form" status-icon label-position="top">
          <el-row :gutter="40">

            <div v-if="$store.getters.isAllCountry" class="flex-box">
              <div>
                <el-col :span="11">
                  <el-form-item
                    :label="$t('data.currency')"
                    prop="currency"
                    :rules="[
                      { required: true, message: $t('data.currency_required'), trigger: ['blur', 'change'] }
                    ]"
                  >
                    <el-select v-model="form.currency" placeholder="Select currency" filterable class="select-item" clearable @change="currencyChange">
                      <el-option
                        v-for="(item, index) in currencyOptions"
                        :key="index"
                        :label="item.currency"
                        :value="item.currency"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </div>
            </div>
            <div class="flex-box">
              <div>
                <el-col :span="11">
                  <el-form-item
                    v-if="currentCountryCode !== 'TH' || form.beneficiary_account_type !== 'PROMPTPAY'"
                    :label="$t('merchantAccount.recipient_channel')"
                    prop="disbursement_channel"
                    :rules="[
                      { required: true, message: 'Receiving channel cannot be empty', trigger: 'blur'}
                    ]"
                  >
                    <el-select v-model="form.disbursement_channel" placeholder="Select receiving channel" filterable class="select-item" clearable @change="disbursementChannelChange">
                      <el-option
                        v-for="(item,index) in bankList"
                        :key="index"
                        :label="item.name_with_full_bank"
                        :value="item.bank_code"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </div>
            </div>
            <div v-if="showBeneficiaryAccountType" class="flex-box">
              <div>
                <el-col :span="11">
                  <el-form-item
                    :label="$t('merchantAccount.beneficiary_account_type')"
                    prop="beneficiary_account_type"
                    :rules="[
                      { required: true, message: 'Beneficiary account type cannot be empty', trigger: 'blur'}
                    ]"
                  >
                    <el-select v-model="form.beneficiary_account_type" placeholder="Select beneficiary account type" filterable class="select-item" @change="beneficiaryAccountTypeChange">
                      <el-option
                        v-for="(item,index) in beneficiaryAccountType"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </div>
            </div>
            <!--收款人类别 - 泰国 PROMPTPAY 或 阿联酋钱包类型-->
            <div v-if="showBeneficiaryType" class="flex-box">
              <div>
                <el-col :span="11">
                  <el-form-item
                    :label="beneficiaryTypeLabel"
                    prop="beneficiary_type"
                    :rules="[
                      { required: true, message: 'Beneficiary type cannot be empty', trigger: 'blur'}
                    ]"
                  >
                    <el-select v-model="form.beneficiary_type" placeholder="Select beneficiary type" filterable class="select-item" clearable @change="beneficiaryTypeChange">
                      <el-option
                        v-for="(item,index) in beneficiaryTypeOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                        :alt="item.label"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </div>
            </div>
            <div class="flex-box">
              <div>
                <el-col :span="11">
                  <el-form-item
                    :label="$t('merchantAccount.recipient_name')"
                    prop="disbursement_name"
                    :rules="[
                      { required: true, message: 'Recipient name cannot be empty', trigger: 'blur'},
                      { validator: checkWhitespace, trigger: 'blur'},
                      { validator: checkName, trigger: 'blur'},
                    ]"
                  >
                    <el-input v-model="form.disbursement_name" placeholder="Enter recipient name" class="search-frame" maxlength="100" autocomplete="off" clearable show-word-limit />
                  </el-form-item>
                </el-col>
              </div>
            </div>
            <div class="flex-box">
              <div>
                <el-col :span="11">
                  <el-form-item
                    :label="$t('send_pagements.recipient_account_number')"
                    prop="disbursement_number"
                    :rules="[
                      { required: true, message: 'Recipient account number cannot be empty', trigger: ['blur','change']},
                      { validator: checkoutAccountNo, trigger: ['blur','change']}
                    ]"
                  >
                    <el-input v-model="form.disbursement_number" placeholder="Enter recipient account number" class="search-frame" maxlength="50" autocomplete="off" clearable show-word-limit />
                  </el-form-item>
                </el-col>
              </div>
            </div>
            <div class="flex-box">
              <div>
                <el-col :span="11">
                  <el-form-item
                    :label="$t('merchantAccount.short_name')"
                    prop="disbursement_short_name"
                    :rules="[
                      { required: true, message: 'Short name cannot be empty', trigger: ['blur','change']},
                      { validator: checkWhitespace, trigger: 'blur'}
                    ]"
                  >
                    <el-input v-model="form.disbursement_short_name" placeholder="Fill in the short name" class="search-frame" maxlength="64" autocomplete="off" clearable show-word-limit />
                  </el-form-item>
                </el-col>
              </div>
            </div>
            <!--海湾六国收款人信息-->
            <template v-if="isGulfCountry">
              <div class="flex-box">
                <div>
                  <el-col :span="11">
                    <el-form-item
                      :label="$t('merchantAccount.beneficiary_iban')"
                      prop="iban"
                      :rules="[
                        { required: true, message: 'Beneficiary IBAN cannot be empty', trigger: 'blur'}
                      ]"
                    >
                      <el-input v-model.trim="form.iban" placeholder="Enter beneficiary IBAN" class="search-frame" autocomplete="off" maxlength="100" clearable />
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <div class="flex-box">
                <div>
                  <el-col :span="11">
                    <el-form-item
                      :label="$t('merchantAccount.beneficiary_swift_code')"
                      prop="swift_code"
                      :rules="[
                        { required: true, message: 'SWIFT Code cannot be empty', trigger: 'blur'}
                      ]"
                    >
                      <el-input v-model.trim="form.swift_code" placeholder="Enter SWIFT code" class="search-frame" autocomplete="off" maxlength="50" clearable />
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <div class="flex-box">
                <div>
                  <el-col :span="11">
                    <el-form-item
                      :label="$t('merchantAccount.beneficiary_bank_address')"
                      prop="bank_address"
                      :rules="[
                        { required: true, message: 'Beneficiary bank address cannot be empty', trigger: 'blur'}
                      ]"
                    >
                      <el-input v-model="form.bank_address" placeholder="Enter beneficiary bank address" class="search-frame" autocomplete="off" maxlength="200" clearable />
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <div class="flex-box">
                <div>
                  <el-col :span="11">
                    <el-form-item
                      :label="$t('merchantAccount.beneficiary_en_first_name')"
                      prop="en_first_name"
                      :rules="[
                        { required: true, message: 'Beneficiary English first name cannot be empty', trigger: 'blur'}
                      ]"
                    >
                      <el-input v-model="form.en_first_name" placeholder="Enter beneficiary English first name" class="search-frame" autocomplete="off" maxlength="100" clearable />
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <div class="flex-box">
                <div>
                  <el-col :span="11">
                    <el-form-item
                      :label="$t('merchantAccount.beneficiary_en_last_name')"
                      prop="en_last_name"
                      :rules="[
                        { required: true, message: 'Beneficiary English last name cannot be empty', trigger: 'blur'}
                      ]"
                    >
                      <el-input v-model="form.en_last_name" placeholder="Enter beneficiary English last name" class="search-frame" autocomplete="off" maxlength="100" clearable />
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <div class="flex-box">
                <div>
                  <el-col :span="11">
                    <el-form-item
                      :label="$t('merchantAccount.beneficiary_native_first_name')"
                      prop="local_first_name"
                      :rules="[
                        { required: true, message: 'Beneficiary native first name cannot be empty', trigger: 'blur'}
                      ]"
                    >
                      <el-input v-model="form.local_first_name" placeholder="Enter beneficiary native first name" class="search-frame" autocomplete="off" maxlength="100" clearable />
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <div class="flex-box">
                <div>
                  <el-col :span="11">
                    <el-form-item
                      :label="$t('merchantAccount.beneficiary_native_last_name')"
                      prop="local_last_name"
                      :rules="[
                        { required: true, message: 'Beneficiary native last name cannot be empty', trigger: 'blur'}
                      ]"
                    >
                      <el-input v-model="form.local_last_name" placeholder="Enter beneficiary native last name" class="search-frame" autocomplete="off" maxlength="100" clearable />
                    </el-form-item>
                  </el-col>
                </div>
              </div>
            </template>
            <!--受益人地址-->
            <div v-if="currentCountryCode === 'AE'" class="flex-box">
              <div>
                <el-col :span="11">
                  <el-form-item
                    :label="$t('map.benefit_address')"
                    prop="beneficiary_address"
                    :rules="[
                      { required: true, message: 'Beneficiary address cannot be empty', trigger: ['blur','change']},
                    ]"
                  >
                    <el-input
                      v-model="form.beneficiary_address"
                      :placeholder="$t('tips.beneficiary_address_name_exceed_140')"
                      type="textarea"
                      :rows="3"
                      autocomplete="off"
                      maxlength="140"
                      show-word-limit
                    />
                  </el-form-item>
                </el-col>
              </div>
            </div>
            <div v-if="currentCountryCode === 'TH'" class="flex-box">
              <div>
                <el-col :span="11">
                  <el-form-item
                    :label="$t('merchantAccount.beneficiary_mobile')"
                    prop="beneficiary_mobile"
                    :rules="[
                      { validator: checkMobile, trigger: ['blur','change'] }
                    ]"
                  >
                    <el-input v-model.trim="form.beneficiary_mobile" placeholder="Enter beneficiary mobile" class="search-frame" autocomplete="off" clearable maxlength="10" show-word-limit />
                  </el-form-item>
                </el-col>
              </div>
            </div>
          </el-row>

          <el-row>

            <el-col :span="11">
              <el-form-item
                :label="$t('customerService.attachments') + ':'"
                prop="contract_attachment_list"
                :rules="[
                  { required: true, message: 'Attachments cannot be empty', trigger: ['blur','change']},
                ]"
              >
                <div>
                  {{ $t('tips.agreement_between_tip') }}
                  <el-link class="check-class" type="primary" @click="showContractModal">
                    {{ $t('components.view') }}
                  </el-link>
                </div>

                <template v-if="form.contract_attachment_list">
                  <div v-for="item in form.contract_attachment_list" :key="item.fileName" class="file-container">
                    <img v-if="isImg(item.fileName)" v-viewer class="content-img reply-content-img" :src="item.absolutePath" alt="">
                    <div v-else class="reply-content-file" @click="onClickIcon(item.fileName,item.absolutePath )">{{ item.fileName }}</div>
                    <el-button type="danger" size="mini" style="margin-left: 10px;" icon="el-icon-delete" @click="onClickRemoveBtn(item)">{{ $t('components.delete') }}</el-button>
                  </div>
                </template>
                <UploadFile accept-type="*" file-dir="DISBURSEMENT_FILE" @templateFileSuccess="templateFileSuccess" v-on="$listeners" @change="contractAttachmentListChange" />
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="24">

              <el-form-item
                :label="$t('data.remark')"
                prop="remark"
                :rules="[
                  { required: true, message: 'Remark cannot be empty', trigger: ['blur','change']},
                  { validator: checkWhitespace, trigger: 'blur'}
                ]"
              >
                <div>
                  {{ $t('tips.large_value_beneficiary_remark_tip') }}
                </div>
                <el-input
                  v-model="form.remark"
                  placeholder="Enter your message here"
                  type="textarea"
                  autocomplete="off"
                  maxlength="256"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button> -->
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn()">{{ $t('components.submit') }}</el-button>
      </div>
    </el-dialog>
    <ContractDescriptionModal ref="ContractDescriptionModal" />
  </div>
</template>

<script>
import {
  createLargeValueBeneficiary,
  createMultiMchLargeValueBeneficiary,
  editLargeValueBeneficiary,
  queryLargeValueBeneficiaryDetail
} from '@/api/online-transaction/online-transaction.js'
import { fetchDisbursementAllCodeList } from '@/api/components/components.js'
import { beneficiaryAccountType, beneficiaryType, beneficiaryTypeOptionsForVN } from '@/utils/maps'
import { GULF_USD_ONLY_COUNTRY_CODES, LARGE_VALUE_PAYMENT_COUNTRY_CODES } from '@/const/const.js'
export default {
  name: 'Single_Disbursement_Modal',
  components: {
    UploadFile: () => import('@/views/components/Upload/UploadFile.vue'),
    ContractDescriptionModal: () => import('./ContractDescriptionModal.vue')
  },
  data() {
    this.BANK = 1
    this.EWALLET = 2
    this.checkWhitespace = (rule, value, callback) => {
      if (value.trim() !== value) {
        return callback(new Error('Please make sure there are no spaces at the beginning or end of your input.'))
      }
      callback()
    }
    this.checkName = (rule, value, callback) => {
      if (!/^[a-zA-Z0-9\s\u0E00-\u0E7F.'-]{1,100}$/.test(value)) {
        return callback(new Error('Please enter the correct name'))
      }
      callback()
    }
    this.checkoutAccountNo = (rule, value, callback) => {
      const bankItem = this.bankList.find(item => item.bank_code === this.form.disbursement_channel) || {}

      if (/\s/g.test(value)) {
        return callback(new Error('The input value cannot contain spaces'))
      }
      if (this.currentCountryCode === 'AE') {
        if (!/^[a-zA-Z0-9]+$/.test(value)) {
          return callback(new Error('Only letters and numbers are allowed'))
        }
      } else {
        if (value !== '0' && !Number(value)) {
          return callback(new Error('Only can input number'))
        }
      }

      const { beneficiary_account_type, beneficiary_type } = this.form
      const isAE = this.currentCountryCode === 'AE'
      // 阿联酋国家钱包类型 + 手机号，校验手机号格式：10位数字，以05开头
      if (isAE && bankItem.bank_type === this.EWALLET && beneficiary_type === 'MOBILE_NUMBER') {
        if (!/^05\d{8}$/.test(value)) {
          return callback(new Error('The wallet account number must be 10 digits starting with 05'))
        }
      }
      // 泰国/菲律宾电子钱包或 PROMPTPAY 手机号格式验证
      if (!isAE && !this.isGulfCountry && (bankItem.bank_type === this.EWALLET || (beneficiary_account_type === 'PROMPTPAY' && beneficiary_type === 'MOBILE_NUMBER'))) {
        if (this.currentCountryCode === 'TH') {
          if (!/^0([689]\d{8})$/.test(value)) {
            return callback(new Error('Please enter the 10 numbers starting with 0, followed by 6, 8, or 9.'))
          }
        } else {
          if (!/(09)\d{9}$/.test(value)) {
            return callback(new Error(' Pls input the correct Recipient account number and start with 09'))
          }
        }
      }
      if (value.trim() !== value) {
        return callback(new Error('Please make sure there are no spaces at the beginning or end of your input.'))
      }
      if (value.length && value.length < 5) {
        return callback(new Error('Please input between 5 to 50 characters.'))
      }
      callback()
    }
    this.checkMobile = (rule, value, callback) => {
      if (value && value !== '0' && !Number(value)) {
        return callback(new Error('Only can input number'))
      }
      if (value && !/^(06|08|09)[0-9]{8}$/.test(value)) {
        return callback(new Error('Please enter the 10 numbers starting with 0, followed by 6, 8, or 9.'))
      }
      callback()
    }
    return {
      bankList: [],
      form: this.getDefaultForm(),
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      initData: {}

    }
  },
  computed: {
    currencyOptions() {
      return this.$store.state.page.countryArr.filter(item => LARGE_VALUE_PAYMENT_COUNTRY_CODES.includes(item.code))
    },
    currentCountryCode() {
      if (!this.$store.getters.isAllCountry) {
        return this.$store.getters.curCountry.country_code
      }
      const selectedCountry = this.$store.state.page.countryArr.find(item => item.currency === this.form.currency)
      return selectedCountry?.code || ''
    },
    beneficiaryAccountType() {
      // 阿联酋国家返回 BANK 和 EWALLET
      if (this.currentCountryCode === 'AE') {
        return [
          { label: this.$t('map.beneficiary_account_type_0'), value: 'BANK' },
          { label: this.$t('map.beneficiary_account_type_2'), value: 'EWALLET' }
        ]
      }
      // 泰国返回 BANK 和 PROMPTPAY
      return beneficiaryAccountType().filter(item => item.value === 'BANK' || item.value === 'PROMPTPAY')
    },
    // 是否是泰国 PROMPTPAY
    isTHPromptPay() {
      return this.currentCountryCode === 'TH' && this.form.beneficiary_account_type === 'PROMPTPAY'
    },
    // 阿联酋国家 + 收款账户类型选择 EWALLET
    isAEWalletType() {
      return this.currentCountryCode === 'AE' && this.form.beneficiary_account_type === 'EWALLET'
    },
    // 是否显示收款账户类型下拉框
    showBeneficiaryAccountType() {
      // 只有泰国显示收款账户类型下拉框
      // 阿联酋国家根据收款渠道类型自动设置，不需要用户选择
      return this.currentCountryCode === 'TH'
    },
    // 是否显示收款人类别下拉框
    showBeneficiaryType() {
      // 越南 VN 国家也显示收款人类别
      if (this.currentCountryCode === 'VN') {
        return true
      }
      return this.isTHPromptPay || this.isAEWalletType
    },
    // 收款人类别 label
    beneficiaryTypeLabel() {
      // 越南 VN 国家显示"收款人账户类型"
      if (this.currentCountryCode === 'VN') {
        return this.$t('merchantAccount.recipient_account_type')
      }
      return this.$t('merchantAccount.beneficiary_type')
    },
    // 收款人类别选项
    beneficiaryTypeOptions() {
      if (this.currentCountryCode === 'VN') {
        // 越南收款人账户类型选项
        return beneficiaryTypeOptionsForVN()
      }
      if (this.isAEWalletType) {
        // 阿联酋钱包类型选项
        return [
          { label: this.$t('merchantAccount.account_type_mobile_number'), value: 'MOBILE_NUMBER' },
          { label: this.$t('merchantAccount.account_type_ewallet_id'), value: 'EWALLET_ID' }
        ]
      }
      // 泰国 PROMPTPAY 选项
      return beneficiaryType().filter(item => item.value === 'NATIONAL_ID' || item.value === 'MOBILE_NUMBER')
    },
    isImg() {
      return function(value) {
        return /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(value)
      }
    },
    dialogTitle() {
      if (this.initData.id) {
        return this.$t('components.edit')
      } else {
        return this.$t('components.create')
      }
    },
    isGulfCountry() {
      // 暂时只针对沙特
      return this.currentCountryCode === 'SA'
      // return GULF_USD_ONLY_COUNTRY_CODES.includes(this.currentCountryCode)
    }
  },
  watch: {
    'form.beneficiary_account_type'(newVal) {
      // 当收款账户类型不是 PROMPTPAY 时，清空收款人类别
      if (newVal !== 'PROMPTPAY') {
        this.form.beneficiary_type = null
      }
    }
  },
  created() {
    if (!this.$store.getters.isAllCountry) {
      this.getAllBank()
    }
  },
  methods: {
    getDefaultForm() {
      return {
        currency: null,
        beneficiary_account_type: null,
        beneficiary_type: null,
        disbursement_channel: null,
        disbursement_name: null,
        disbursement_number: null,
        disbursement_short_name: null,
        beneficiary_address: null,
        beneficiary_mobile: null,
        remark: null,
        contract_attachment_list: [],
        iban: null,
        swift_code: null,
        bank_address: null,
        en_first_name: null,
        en_last_name: null,
        local_first_name: null,
        local_last_name: null
      }
    },
    showModal(row) {
      this.dialogVisible = true
      if (row) {
        this.getDetail(row)
        this.initData = row
      }
    },
    showContractModal() {
      this.$refs.ContractDescriptionModal.showModal()
    },
    getDetail(row) {
      queryLargeValueBeneficiaryDetail({ id: row.id }).then(res => {
        const { currency, beneficiary_account_type, beneficiary_mobile, beneficiary_type, remark, disbursement_short_name, disbursement_number, disbursement_name, disbursement_channel, contract_attachment_list = [], beneficiary_address, iban, swift_code, bank_address, en_first_name, en_last_name, local_first_name, local_last_name } = res.data
        const list = contract_attachment_list.map(item => {
          return { fileName: item.file_name,
            absolutePath: item.file_oss_url, relativePath: item.file_path, file_path: item.file_path }
        })
        Object.assign(this.form, {
          currency, beneficiary_account_type, beneficiary_mobile, beneficiary_type, remark, disbursement_short_name, disbursement_number, disbursement_name, disbursement_channel, beneficiary_address,
          contract_attachment_list: list,
          iban, swift_code, bank_address, en_first_name, en_last_name, local_first_name, local_last_name
        })
        if (this.$store.getters.isAllCountry && currency) {
          this.getAllBank(currency)
        }
      })
    },
    currencyChange(currency) {
      this.bankList = []
      this.form.disbursement_channel = null
      this.form.disbursement_number = null
      if (currency) {
        this.getAllBank(currency)
      }
    },
    disbursementChannelChange() {
      if (this.form.disbursement_channel) {
        this.$nextTick(function() {
          this.$refs['form'].clearValidate(['disbursement_channel'])
        })
      }
      this.form.disbursement_number = null
      this.form.beneficiary_type = null
      // 阿联酋/越南国家根据收款渠道类型自动设置收款账户类型
      const countryCode = this.currentCountryCode
      if (countryCode === 'AE' || countryCode === 'VN') {
        const selectedBank = this.bankList.find(item => item.bank_code === this.form.disbursement_channel)
        if (selectedBank) {
          // bank_type === 2 钱包类型 → EWALLET
          // bank_type === 1 银行类型 → BANK
          this.form.beneficiary_account_type = selectedBank.bank_type === this.EWALLET ? 'EWALLET' : 'BANK'
        } else {
          this.form.beneficiary_account_type = null
        }
      }
      this.$nextTick(function() {
        this.$refs['form'].clearValidate(['disbursement_number', 'beneficiary_type', 'beneficiary_account_type'])
      })
    },
    beneficiaryAccountTypeChange() {
      if (this.form.beneficiary_account_type) {
        this.$nextTick(function() {
          this.$refs['form'].clearValidate(['beneficiary_account_type'])
        })
      }
      this.form.beneficiary_type = null
      this.form.disbursement_number = null
      this.$nextTick(function() {
        this.$refs['form'].clearValidate(['beneficiary_type', 'disbursement_number'])
      })
    },
    beneficiaryTypeChange() {
      if (this.form.beneficiary_type) {
        this.$nextTick(function() {
          this.$refs['form'].clearValidate(['beneficiary_type'])
        })
      }
      this.form.disbursement_number = null
      this.$nextTick(function() {
        this.$refs['form'].clearValidate(['disbursement_number'])
      })
    },
    contractAttachmentListChange() {
      if (this.form.contract_attachment_list) {
        this.$nextTick(function() {
          this.$refs['form'].clearValidate(['contract_attachment_list'])
        })
      }
    },
    clearValidate(formName) {
      this.$nextTick(function() {
        this.$refs[formName].clearValidate()
      })
    },
    templateFileSuccess(data) {
      this.form.contract_attachment_list.push(data)
    },
    onClickRemoveBtn(item) {
      this.form.contract_attachment_list = this.form.contract_attachment_list.filter(i => i.absolutePath !== item.absolutePath)
    },

    getAllBank(currency) {
      let params = {}
      if (this.$store.getters.isAllCountry) {
        const selectedCurrency = this.currencyOptions.find(item => item.currency === currency)
        if (!selectedCurrency) {
          this.bankList = []
          return
        }
        params = { country_code: selectedCurrency.code }
      }
      fetchDisbursementAllCodeList(params).then(res => {
        const list = res.data
        list.map(item => {
          item.name_with_full_bank = item.bank_code
          if (item.bank_type === this.BANK) {
            item.name_with_full_bank = item.bank_code + ' - ' + item.full_name
          }
          return item
        })
        this.bankList = list
      })
    },
    onClickSubmitBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 阿联酋国家：收款人名称+受益人地址不能超过140字符
          if (this.currentCountryCode === 'AE') {
            const disbursementName = this.form.disbursement_name || ''
            const beneficiaryAddress = this.form.beneficiary_address || ''
            if ((disbursementName.length + beneficiaryAddress.length) > 140) {
              this.$message.error(this.$t('tips.beneficiary_address_name_exceed_140'))
              return
            }
          }
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.submiting = true
            const { contract_attachment_list, ...otherForm } = this.form
            const params = { ...otherForm }
            if (!this.$store.getters.isAllCountry) {
              delete params.currency
            }
            if (Array.isArray(contract_attachment_list) && contract_attachment_list.length > 0) {
              params.contract_attachment_list = contract_attachment_list.map(item => {
                return {
                  file_path: item.relativePath,
                  file_name: item.fileName
                }
              })
            }
            if (params.disbursement_number) {
              params.disbursement_number = params.disbursement_number.trim()
            }
            if (params.disbursement_name) {
              params.disbursement_name = params.disbursement_name.trim()
            }
            if (!params.beneficiary_mobile) {
              params.beneficiary_mobile = null
            }
            // 泰国 PROMPTPAY 不需要传收款渠道
            if (this.currentCountryCode === 'TH' && params.beneficiary_account_type === 'PROMPTPAY') {
              delete params.disbursement_channel
            }
            // 选择 BANK 时不需要传收款人类别（越南除外，越南需要同时保留 beneficiary_type）
            if (params.beneficiary_account_type === 'BANK' && this.currentCountryCode !== 'VN') {
              delete params.beneficiary_type
            }
            let requestEvent = this.$store.getters.isAllCountry
              ? createMultiMchLargeValueBeneficiary
              : createLargeValueBeneficiary
            if (this.initData.id) {
              params.id = this.initData.id
              requestEvent = editLargeValueBeneficiary
            }
            requestEvent(params).then(res => {
              if (res.code === 10000) {
                this.dialogVisible = false
                this.$emit('updateList')
              }
            }).finally(() => {
              this.submiting = false
            })
          })
        }
      })
    },
    onClose() {
      this.initData = {}
      Object.assign(this.form, this.getDefaultForm())
      if (this.$store.getters.isAllCountry) {
        this.bankList = []
      }
      this.clearValidate('form')
    },
    onClickIcon(fileName, url) {
      window.open(url, '_blank')
    }
  }

}
</script>

<style scoped>
.form-container /deep/ .el-input__inner{
  padding-right: 80px;
}
.select-item{
  width:100%;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  width: 500px;
  height: 40px;
  border-radius: 4px;
}
.file-container{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.content-img{
  cursor: pointer;
  height: 100px;
  max-width: 300px;
}
.content-file{
  color:#3855F1;
  text-decoration: underline;
  cursor: pointer;
}

.reply-content-img{
  margin-bottom: 10px;
}
.reply-content-file{
  display: inline-block;
  width: 200px;
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: underline;
  vertical-align: middle;
  color: #3855F1;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.check-class{
  color: #3855F1;
  margin-top: -2px;
  margin-left: -3px
}
.mt-12{
  margin-top: 12px;
}
.search-frame{
}
</style>
